import { useSelector } from 'react-redux';
import { SupportedChainId } from '@orionprotocol/sdk';

import { getAppChainId } from '../../redux/selectors';

export function useAppChainId(): SupportedChainId {
  const chainId = useSelector(getAppChainId);

  return chainId;
}
